<swal
  #confirmResetPasswordSwal
  title="Reset Password"
  icon="info"
  confirmButtonColor="#962431"
  confirmButtonText="Save"
  [showCancelButton]="true"
  [preConfirm]="preConfirmResetPassword"
>
  <ng-container *swalPortal="swalTargets.content">
    <div class="sa-custom-content text-left">
      <div class="input-component-container m-b-1-25">
        <div class="input-field required">
          <label for="new-password">New Password</label>
          <input
            name="new-password"
            (keydown)="onKeyDown($event, '#new-password-confirmation')"
            id="new-password"
            class="d-block b-secondary-lighter"
            value=""
            type="password"
            autocomplete="new-password"
          />
        </div>
        <div class="input-field required">
          <label for="new-password-confirmation">Confirm New Password</label>
          <input
            name="new-password-confirmation"
            (keydown)="onKeyDown($event, 'div.sa-confirm-button-container button.confirm')"
            id="new-password-confirmation"
            class="d-block b-secondary-lighter"
            value=""
            type="password"
            autocomplete="new-password"
          />
        </div>
      </div>
    </div>
  </ng-container>
</swal>
